﻿import {setFilterValue} from "./overview-filter-value";
import config from './config.json';
import {attributes} from "./overview-filter-constants";

const findGeolocationButton = (filter) => {
	return document.querySelector(`[${attributes.filterGeoButton}=${filter}]`);
}

const fetchLocation = (filter) => {
	const geolocation = navigator.geolocation;

	if (geolocation) {
		geolocation.getCurrentPosition(
			(geolocation) => setCurrentPosition(filter, geolocation.coords),
			() => {
			});
	}
}

const setCurrentPosition = async (filter, {latitude, longitude}) => {
	const response = await fetch(`${config.basepath}/location?latitude=${latitude}&longitude=${longitude}`);

	if (!response.ok) return;
	const data = await response.json();

	await setFilterValue(filter, data);
}

export const bindLocationForValueFilter = (filter) => {
	const geolocationButton = findGeolocationButton(filter);
	geolocationButton.addEventListener("click", () => fetchLocation(filter));
}
